import './reason-editor.scss';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { HandleData } from '@core/app/scripts/services/handle-data';

/*
 * Component responsible for /reason-editor route.
 */
angular
  .module('posApp')
  .directive(
    'reasonEditor',
    (
      $rootScope: ng.IRootScopeService,
      handleData: HandleData,
      pos,
      displayMessage: DisplayMessage,
      navigateTo: NavigateTo,
      translate: ng.translate.ITranslateService,
      utility,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./reason-editor.html').default,

      link: function ($scope: any) {
        const $translate = translate;

        $scope.selectedCat = false;
        $scope.categories = {};
        let originals = {};

        const reset = () => {
          delete $scope.id;
          $scope.selectedCat = false;
          $scope.categories = {};
          $scope.catName = '';
        };
        let acls = pos.config;

        if (acls) {
          acls = acls.acls;
        }

        $scope.cancel = () => {
          reset();
          navigateTo('pos.route#more');
        };

        $scope.save = () => {
          //new user
          if ($scope.id === null) {
            $scope.id = utility.uuid();
          }
          const data = {
            _id: $scope.id,
          };
          for (const i in $scope.categories) {
            const values = angular.copy($scope.categories[i].values);
            if ($scope.categories[i].name !== 'DiscountReasons') {
              for (const j in values) {
                values[j] = values[j].string;
              }
            }
            data[i] = values;
          }
          const saved = () => {
            const message = $translate.instant('DataSaveSuccess');
            displayMessage.message({
              message: message,
              type: 'info',
              callback: null,
              mini: true,
            });
          };
          handleData.saveData(
            {
              resource: 'pos_reasons',
            },
            data,
            saved,
          );
        };

        $scope.selectCat = (cat) => {
          $scope.selectedCat = cat;
        };

        $scope.deleteItem = (cat, i) => {
          console.log(cat.values);
          cat.values.splice(i, 1);
          console.log(cat.values);
        };

        $scope.newItem = (cat) => {
          if (cat.name === 'DiscountReasons') {
            cat.values.push({
              key: '',
              desc: '',
            });
          } else {
            cat.values.push({
              string: '',
            });
          }
        };

        const reasonsSuc = (r) => {
          if (!r || !r.data || !r.data[0]) {
            displayMessage.message($translate.instant('NoReasonsFound'));
            $scope.id = null;
            return;
          }
          const reasons = r.data[0];
          let cat;
          $scope.id = reasons._id;
          for (const i in reasons) {
            if (i == 'created') {
              continue;
            }
            if (i == '_id') {
              continue;
            }
            if (i == 'tenant_id') {
              continue;
            }
            if (i == 'modified') {
              continue;
            }
            cat = {};
            cat.name = i;
            cat.values = reasons[i];
            if (cat.name !== 'DiscountReasons') {
              for (const j in cat.values) {
                //wrapped to enable angular to properly bind the string
                cat.values[j] = {
                  string: cat.values[j],
                };
              }
            }
            $scope.categories[i] = cat;
            originals = angular.copy(cat);
          }
        };

        $scope.loadReasons = () => {
          handleData.getData(
            {
              resource: 'pos_reasons',
            },
            {},
            reasonsSuc,
          );
        };

        // ngOnInit
        $scope.loadReasons();
      },
    }),
  );
